import React, { createContext, useContext, useState, useEffect } from 'react';

/**
 * ------------------------------------------------------------------
 * INDICE DE FUNCIONES Y ESTRUCTURA
 * ------------------------------------------------------------------
 * 1. Context Creation .................... Creación del contexto
 * 2. Custom Hook (useTheme) .............. Hook para usar el tema
 * 3. Provider (ThemeProvider) ............ Componente proveedor
 *    - State (dark) ...................... Estado del tema (oscuro/claro)
 *    - toggleTheme ....................... Alternar entre temas
 *    - Persistence ....................... Guardado en localStorage
 * ------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------
 * 1. Context Creation
 * ------------------------------------------------------------------
 */
const ThemeContext = createContext();

/**
 * ------------------------------------------------------------------
 * 2. Custom Hook (useTheme)
 * ------------------------------------------------------------------
 */
export function useTheme() {
  return useContext(ThemeContext);
}

/**
 * ------------------------------------------------------------------
 * 3. Provider (ThemeProvider)
 * ------------------------------------------------------------------
 */
export function ThemeProvider({ children }) {
  // State (dark)
  const [dark, setDark] = useState(() => {
    // Intenta leer del localStorage, por defecto modo claro
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) return stored === 'true';
    // Por defecto: modo claro (false)
    return false;
  });

  // Persistence
  useEffect(() => {
    document.body.classList.toggle('dark-mode', dark);
    localStorage.setItem('darkMode', dark);
  }, [dark]);

  // toggleTheme
  const toggleTheme = () => setDark(d => !d);

  // setTheme - permite establecer un tema específico
  const setTheme = (theme) => setDark(theme === 'dark');

  return (
    <ThemeContext.Provider value={{ dark, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}